import React from "react";
import { useState } from "react";

// Replacing imports with temporary inline components to resolve path issues
const Button = ({ children, className, ...props }) => (
  <button
    className={`px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 ${className}`}
    {...props}
  >
    {children}
  </button>
);

const Input = ({ name, value, onChange, placeholder }) => (
  <input
    type="text"
    name={name}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    className="w-full p-2 border border-gray-300 rounded"
  />
);

const Textarea = ({ name, value, onChange, placeholder }) => (
  <textarea
    name={name}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    className="w-full p-2 border border-gray-300 rounded"
  />
);

const Select = ({ name, value, onChange, children }) => (
  <select
    name={name}
    value={value}
    onChange={onChange}
    className="w-full p-2 border border-gray-300 rounded"
  >
    {children}
  </select>
);

export default function RabiesForm() {
  const [formData, setFormData] = useState({
    practiceName: "",
    practiceAddress: "",
    telephoneNumber: "",
    emailAddress: "",
    testRequired: "",
    extraReports: false,
    extraReportsEmail: "",
    extraReportsAddress: "",
    ownerName: "",
    ownerAddress: "",
    animalName: "",
    microchipNumber: "",
    species: "",
    breed: "",
    sex: "",
    age: "",
    vaccinationDate: "",
    samplingDate: "",
    destinationCountry: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-6">Request for Determination of Antibodies Against Rabies</h1>
      <form onSubmit={handleSubmit} className="bg-white p-6 shadow-md rounded-lg">
        <div className="mb-4">
          <label className="block font-medium">Practice Name</label>
          <Input
            name="practiceName"
            value={formData.practiceName}
            onChange={handleInputChange}
            placeholder="Enter practice name"
          />
        </div>

        <div className="mb-4">
          <label className="block font-medium">Practice Address</label>
          <Textarea
            name="practiceAddress"
            value={formData.practiceAddress}
            onChange={handleInputChange}
            placeholder="Enter practice address"
          />
        </div>

        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block font-medium">Telephone Number</label>
            <Input
              name="telephoneNumber"
              value={formData.telephoneNumber}
              onChange={handleInputChange}
              placeholder="Enter phone number"
            />
          </div>
          <div>
            <label className="block font-medium">Email Address</label>
            <Input
              name="emailAddress"
              value={formData.emailAddress}
              onChange={handleInputChange}
              placeholder="Enter email address"
            />
          </div>
        </div>

        <div className="mb-4">
          <label className="block font-medium">Test Required</label>
          <Select
            name="testRequired"
            value={formData.testRequired}
            onChange={handleInputChange}
          >
            <option value="">Select a test</option>
            <option value="TC0712">Reduced Titration</option>
            <option value="TC0570">Full Titration</option>
          </Select>
        </div>

        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="extraReports"
              checked={formData.extraReports}
              onChange={handleCheckboxChange}
              className="mr-2"
            />
            Are extra reports required?
          </label>
        </div>

        {formData.extraReports && (
          <>
            <div className="mb-4">
              <label className="block font-medium">Extra Reports Email</label>
              <Input
                name="extraReportsEmail"
                value={formData.extraReportsEmail}
                onChange={handleInputChange}
                placeholder="Enter email for extra reports"
              />
            </div>
            <div className="mb-4">
              <label className="block font-medium">Extra Reports Address</label>
              <Textarea
                name="extraReportsAddress"
                value={formData.extraReportsAddress}
                onChange={handleInputChange}
                placeholder="Enter address for extra reports"
              />
            </div>
          </>
        )}

        {/* Additional fields for Owner, Animal, and other details */}

        <Button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600">
          Submit
        </Button>
      </form>
    </div>
  );
}
